import { RefObject } from "react";
import { cn } from "@util/helpers";
import { motion, useScroll } from "motion/react";

type ProgressBarProps = {
  /** Reference to the article content element for scroll tracking */
  articleContentProgress: RefObject<HTMLDivElement>;
  /** Optional CSS class to apply to the progress bar container */
  className?: string;
  /** Flag to indicate to display progress bar */
  isDisplayed?: boolean;
};

/**
 * ProgressBar component that displays a progress bar for article.
 */
const ProgressBar = ({
  className,
  articleContentProgress,
  isDisplayed,
}: ProgressBarProps): React.ReactElement => {
  const { scrollYProgress } = useScroll({ target: articleContentProgress });

  return (
    <motion.div
      className={cn(
        "no-print sticky left-0 right-0 top-0 z-20 h-[2px] w-full bg-gray-850",
        className
      )}
      animate={{ opacity: isDisplayed ? 1 : 0 }}
      style={{
        scaleX: scrollYProgress,
        originX: 0,
      }}
    />
  );
};

export default ProgressBar;
